import { SPECIAL_BUILDINGS } from "@dein-go-city/shared";
import { applyPanel } from "./UiPanel";
import { PARCHMENT, LAYERS, DANGER } from "./theme";
import { setCursor, isPlacementActive } from "./cursor";
import { createModal } from "./Modal";
let dom = null;
function getDom() {
    if (dom)
        return dom;
    const overlay = document.createElement("div");
    overlay.style.cssText = `
    position: fixed;
    inset: 0;
    z-index: ${LAYERS.destroyConfirmBackdrop};
    background: rgba(0,0,0,0.55);
    display: none;
  `;
    overlay.addEventListener("click", () => hide());
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.destroyConfirmPanel};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    font-family: ui-sans-serif, system-ui, sans-serif;
    box-shadow: 0 16px 56px rgba(0,0,0,0.55);
    padding: 16px 18px;
    display: none;
  `;
    applyPanel(panel, "beigeLight");
    const title = document.createElement("div");
    title.style.cssText = `
    font-size: 14px;
    font-weight: 700;
    color: ${PARCHMENT.text};
    margin-bottom: 8px;
  `;
    const refundLine = document.createElement("div");
    refundLine.style.cssText = `
    font-size: 12px;
    color: ${PARCHMENT.textMuted};
    line-height: 1.4;
    margin-bottom: 12px;
  `;
    const errorLine = document.createElement("div");
    errorLine.style.cssText = `
    font-size: 11px;
    color: ${DANGER};
    margin-bottom: 8px;
    display: none;
  `;
    const actions = document.createElement("div");
    actions.style.cssText = "display: flex; gap: 8px; justify-content: flex-end;";
    const cancelBtn = document.createElement("button");
    cancelBtn.textContent = "Abbrechen";
    cancelBtn.style.cssText = `
    padding: 5px 12px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    border: 1px solid ${PARCHMENT.divider};
    background: transparent;
    color: ${PARCHMENT.text};
  `;
    cancelBtn.addEventListener("click", () => hide());
    const confirmBtn = document.createElement("button");
    confirmBtn.textContent = "Abreißen";
    confirmBtn.style.cssText = `
    padding: 5px 12px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    border: 1px solid rgba(168, 58, 58, 0.5);
    background: rgba(168, 58, 58, 0.12);
    color: ${DANGER};
  `;
    actions.append(cancelBtn, confirmBtn);
    panel.append(title, refundLine, errorLine, actions);
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    const modal = createModal({ panel, labelledBy: title });
    dom = {
        overlay,
        panel,
        title,
        refundLine,
        errorLine,
        confirmBtn,
        cancelBtn,
        modal,
    };
    return dom;
}
function hide() {
    if (dom) {
        dom.panel.style.display = "none";
        dom.overlay.style.display = "none";
        dom.modal.close();
    }
    // The overlay sat on top of the canvas while open, so the building's own pointerleave never
    // fired even though the pointer is no longer over it (dismissed via outside click, Escape, or
    // Cancel) — without this the shovel cursor from the tap that opened the modal stays stuck.
    if (!isPlacementActive())
        setCursor("idle");
}
const BRIDGE_BLOCKED_MESSAGE = "Diese Brücke verbindet zwei Teile des Straßennetzes und kann nicht abgerissen werden.";
export function showDestroyConfirm(building, onConfirm) {
    const d = getDom();
    const def = building.specialType
        ? SPECIAL_BUILDINGS[building.specialType]
        : undefined;
    d.title.textContent = `${def?.name ?? building.title} abreißen?`;
    d.errorLine.textContent = "";
    d.errorLine.style.display = "none";
    // Known up front from MapState (see mapState.ts's `destructible`) — no need to round-trip
    // to the server just to find out this bridge can't be removed.
    const blocked = building.destructible === false;
    d.confirmBtn.style.display = blocked ? "none" : "";
    d.cancelBtn.textContent = blocked ? "Schließen" : "Abbrechen";
    d.confirmBtn.disabled = false;
    d.cancelBtn.disabled = false;
    if (blocked) {
        d.refundLine.textContent = BRIDGE_BLOCKED_MESSAGE;
    }
    else {
        const halfWood = Math.floor((def?.cost.wood ?? 0) / 2);
        const halfSteel = Math.floor((def?.cost.steel ?? 0) / 2);
        const halfManpower = Math.floor((def?.cost.manpower ?? 0) / 2);
        const parts = [
            halfWood ? `${halfWood} Holz` : null,
            halfSteel ? `${halfSteel} Stahl` : null,
            halfManpower ? `${halfManpower} Arbeit` : null,
        ].filter((p) => p !== null);
        d.refundLine.textContent = parts.length
            ? `Du erhältst die Hälfte der Baukosten zurück: ${parts.join(", ")}.`
            : "Es werden keine Ressourcen zurückerstattet.";
    }
    d.confirmBtn.onclick = () => {
        d.confirmBtn.disabled = true;
        d.cancelBtn.disabled = true;
        d.errorLine.style.display = "none";
        void onConfirm().then((result) => {
            if (result.ok) {
                hide();
            }
            else {
                d.confirmBtn.disabled = false;
                d.cancelBtn.disabled = false;
                d.errorLine.textContent = result.error;
                d.errorLine.style.display = "";
            }
        });
    };
    d.overlay.style.display = "block";
    d.panel.style.display = "block";
    d.modal.open(hide);
}
